<div class="delivery-planning__body">
  <app-delivery-grid
    [rows]="rows()"
    [shiftColumns]="shiftColumns()"
    [timeScale]="timeScale()"
    [colorBy]="colorBy()"
    [selectedShiftIds]="selectedShiftIds()"
    (rowClick)="openBlast($event)"
    (deliveryClick)="openDelivery($event)"
    (shiftToggle)="toggleShift($event)" />

  @if (loading()) {
    <div class="delivery-planning__overlay" role="status" aria-live="polite">
      <span class="delivery-planning__spinner" aria-hidden="true"></span>
      <span>{{ 'PLANNING.LOADING' | translate }}</span>
    </div>
  } @else if (rows().length === 0) {
    <div class="delivery-planning__empty">{{ 'PLANNING.NO_DELIVERY_ACTIVITY' | translate }}</div>
  }
</div>
